import { Link } from "react-router-dom";
import { Card, Typography } from "antd";
import CustomButton from "src/components/common/CustomButton";

type Props = {
  status?: number;
};

export default function ErrorPage({ status }: Props) {
  const message =
    status === 404
      ? "요청한 페이지를 찾을 수 없습니다."
      : status === 403
        ? "접근 권한이 없습니다."
        : status === 500
          ? "서버 오류가 발생했습니다."
          : "알 수 없는 오류가 발생했습니다.";

  return (
    <div style={{ padding: 24 }}>
      <Card style={{ borderRadius: 12 }} bordered>
        <Typography.Title level={4} style={{ fontWeight: 900, marginBottom: 8 }}>
          {status} Error
        </Typography.Title>
        <Typography.Text style={{ color: "#8c8c8c" }}>{message}</Typography.Text>
        <div style={{ marginTop: 16 }}>
          <CustomButton variant="contained" component={Link} to="/">
            대시보드로 이동
          </CustomButton>
        </div>
      </Card>
    </div>
  );
}
